import * as React from "react";

const MOBILE_BREAKPOINT = 768;

function subscribe(onChange: () => void): () => void {
  const query = window.matchMedia(`(max-width: ${String(MOBILE_BREAKPOINT - 1)}px)`);
  query.addEventListener("change", onChange);
  return function unsubscribe(): void {
    query.removeEventListener("change", onChange);
  };
}

function isMobileNow(): boolean {
  return window.innerWidth < MOBILE_BREAKPOINT;
}

function isMobileOnServer(): boolean {
  return false;
}

/**
 * Tracks the sidebar's mobile breakpoint. `useSyncExternalStore` keeps the first
 * render in sync with the real viewport, so the sidebar never renders its
 * desktop rail for one frame before collapsing.
 */
export function useIsMobile(): boolean {
  return React.useSyncExternalStore(subscribe, isMobileNow, isMobileOnServer);
}
